module.exports = __webpack_public_path__ + "static/media/eng_d_2029.dde0b6cd.mp4";